export function logError(error, info) {
  // add sentry logger
  console.log('Error caught in boundary', error, info);
}